import { useTranslation } from 'react-i18next'

import RadioGroup from '@/components/Button/RadioGroup'
import Message from '@/components/Chat/Message'
import { useAppState } from '@/composables/useAppState'
import { useTransComponents } from '@/composables/useTransComponents'
import { Audience } from '@/state/AppConfig'

import Conversation from '../Chat/Conversation'

export type QuestionsPreliminaryProps = {
  className?: string
  onChoose: (choice: string) => void
  appearProfile?: boolean
}

export default function QuestionsPreliminary({ className, onChoose, appearProfile }: QuestionsPreliminaryProps) {
  const { t } = useTranslation()
  const { components } = useTransComponents()

  const { context } = useAppState()

  const { persona } = context

  return (
    <Conversation
      persona={persona}
      className={`QuestionsPreliminary pt-[240px] md:pt-[15%] max-md:pb-[53.333vw] relative z-2  ${className ? className : ''}`}
      appearProfile={appearProfile}
      ariaHeading={t('questions.aria.preliminary.heading')}
    >
      <>
        {/* <Message delay={0.3} className='mb-8 ml-48 mr-28 md:ml-56 md:mr-32 col-start-1 md:col-start-1 col-span-10 md:col-span-5'>
        <Trans
          i18nKey='questions.summary.detail'
          values={{
            relationship: relationship,
            difference: interestedBy,
          }}
          components={components}
        />
      </Message> */}
        <Message className='mb-20 ml-48 md:ml-56 md:mr-32 col-start-1 md:col-start-1 col-span-10 md:col-span-5 mt-20'>
          {t('questions.preliminary.relationship.question')}
        </Message>

        <span className='sr-only'>{t('questions.aria.preliminary.instruction')}</span>
        <RadioGroup
          appear
          appearDelay={0.3}
          hasParticles={true}
          onChange={onChoose}
          className='fixed inset-x-12 bottom-0 md:static md:inset-auto md:bottom-auto mb-16 md:ml-56 mt-auto md:mt-0 flex flex-col md:flex-row gap-8 md:gap-12 col-start-1 col-span-12'
          // choices={[
          //   {
          //     label: t('questions.summary.yes'),
          //     value: 'yes'
          //   },
          //   {
          //     label: t('questions.summary.no-start'),
          //     value: 'no-start'
          //   },
          //   {
          //     label: t('questions.summary.no-back'),
          //     value: 'no-back'
          //   },
          // ]}
          choices={[
            {
              label: t('questions.preliminary.relationship.educator'),
              value: 'EDUCATOR' as Audience,
            },
            {
              label: t('questions.preliminary.relationship.parent'),
              value: 'PARENT' as Audience,
            },
            {
              label: t('questions.preliminary.relationship.child'),
              value: 'CHILD' as Audience,
            },
          ]}
          name='summary'
        />
      </>
    </Conversation>
  )
}
